// extracted by mini-css-extract-plugin
export default {"status":"currentStatus__status--ocLEH","active":"currentStatus__active--qVVlD"};